import { createContext, useContext, useState } from 'react';

const Ctx = createContext(null);

export function EnergyProvider({ children }) {
    const [varmetab, setVarmetab] = useState({ netto: null, design: null });
    return (
        <Ctx.Provider value={{ varmetab, setVarmetab }}>
            {children}
        </Ctx.Provider>
    );
}

export function useEnergyStore() {
    const ctx = useContext(Ctx);
    if (!ctx) throw new Error('useEnergyStore must be inside <EnergyProvider>');
    return ctx;
}
